import { RouteResponse } from "../stores/RouteStore";

export function GetRouteName(routeResponse: RouteResponse, routeIndex: number ): string {

    const route = routeResponse.routes[routeIndex];
    if (route && route.routeName) {
        return route.routeName;
    }

    return `Rute${routeIndex+1}`
}